import React from 'react';

import Spaced from 'components/Spaced';
import styles from './Container.module.css';

const Container: React.FCWithChildren = ({ children }) => {
  return (
    <div className={styles.root}>
      <Spaced spacing={6}>{children}</Spaced>
    </div>
  );
};

export default Container;
